import { Injectable, OnDestroy } from '@angular/core';
import { IHistoryNavigation } from '../models/history-navigation.model';

@Injectable()
export class SessionStorageService{
  public historyNavigation: IHistoryNavigation;
  sessionStorageName: string = 'historyNavigation';

  constructor() {
    this.getHistoryNavigation();
  }

  getHistoryNavigation() {
    if (sessionStorage.getItem(this.sessionStorageName)) {
      this.historyNavigation = JSON.parse(
        sessionStorage.getItem(this.sessionStorageName)
      );
    } else {
      this.historyNavigation = JSON.parse(
        JSON.stringify({
          company: null,
          status: null,
          sort: null,
          search: null,
          summaryOpenIvoice: null,
          origin: null,
          destination: null,
          pendingPayment: null,
          page: null,
          favorite: null,
          childrenStatus: null
        })
      );
    }
  }

  cleanAllExceptCompany() {
    Object.keys(this.historyNavigation).forEach(key => {
      if (key !== 'company') {
        this.historyNavigation[key] == null;
      }
    });
    this.saveChanges();
  }

  cleanAll() {
    sessionStorage.removeItem(this.sessionStorageName);
  }

  setProperty(name: string, id: number | string, value: any) {
    this.historyNavigation[name] = { id: id, value: value };
    this.saveChanges();
  }

  saveChanges() {
    sessionStorage.setItem(
      this.sessionStorageName,
      JSON.stringify(this.historyNavigation)
    );
  }

  removeProperty(name: string) {
    this.historyNavigation[name] = null;
    this.saveChanges();
  }

  getProperty(name: string): any {
    this.getHistoryNavigation();
    return this.historyNavigation[name];
  }
  
  isActiveTab(tabName: string): boolean {
    if (this.historyNavigation.status && this.historyNavigation.status.value) {
      return this.historyNavigation.status.value.active_tab === tabName;
    }
    return false;
  }

  setTabSpecificProperty(tabName: string, propertyName: string, value: any) {
    const key = `${tabName}_${propertyName}`;
    this.historyNavigation[key] = { id: 0, value: value };
    this.saveChanges();
  }

  getTabSpecificProperty(tabName: string, propertyName: string): any {
    this.getHistoryNavigation();
    const key = `${tabName}_${propertyName}`;
    return this.historyNavigation[key];
  }

  removeTabSpecificProperty(tabName: string, propertyName: string) {
    const key = `${tabName}_${propertyName}`;
    this.historyNavigation[key] = null;
    this.saveChanges();
  }
}
